export enum FilterType {
  Requirement = 'requirement',
  SeamGeometry = 'seamGeometry',
  Material = 'material',
  SheetThickness = 'sheetThickness',
}
